module.exports = __webpack_public_path__ + "03947746e3aca4816a5a7b5a04c0bd6c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/carousel-1.png
// module id = 210
// module chunks = 0